import React from 'react';
import { Typography, Grid, Box } from '@mui/material';

import BookingHeader from '../../BookingDetail/BookingHeader';
import BookingImage from '../../BookingDetail/BookingImage';
import BookingBasicInfo from '../../BookingDetail/BookingBasicInfo';
import HotelDescription from '../../HotelDetail/BoxHotelDetails/HotelDescription';
import BookingRemarks from '../../BookingDetail/BookingRemarks';

import { sxStyle } from './styles';
import SeeRefundability from '../../helpers/SeeRefundability';

const BookingDoneDetail = ({ datos }) => {
  const {
    room,
    hotelDetails,
    search,
    pagos,
    hotelsValidateResult,
    cancelationFee,
  } = datos;

  return (
    <Box sx={sxStyle.divBookingDetail}>
      <Grid container sx={sxStyle.gridContainerBookingDetail} spacing={2}>
        {/* Título */}
        <Grid item xs={12}>
          <Typography sx={sxStyle.bookingDetailTitle}>
            Detalle de tu {pagos ? 'Compra' : 'Reserva'}
          </Typography>
        </Grid>

        {/* Imagen + Header + Info básica */}
        <Grid container item spacing={2} sx={{ mb: 3 }}>
          {/* Imagen */}
          <Grid item xs={12} md={8}>
            <BookingImage hotelDetails={hotelDetails} />
          </Grid>

          {/* Header + Info básica */}
          <Grid item xs={12} md={4}>
            <BookingHeader
              name={hotelDetails.name}
              rating={hotelDetails.rating}
              layout="doneDetail"
            />

            <BookingBasicInfo
              hotelDetails={hotelDetails}
              room={room}
              searchData={search}
            />
            <SeeRefundability
              index={'BookingDoneDetail-SeeRefundability'}
              check_in={search.checkIn}
              cancelationFee={cancelationFee}
              taxAlign={'start'}
              textDirection={'row'}
              textPadding={0}
              subtitleTransform={'lowercase'}
              isaBuying={pagos}
              hotelCancelationFeeError={cancelationFee?.error}
            />
          </Grid>
        </Grid>

        {/* Descripción y amenities */}
        <Grid item xs={12}>
          <HotelDescription descriptionHotel={hotelDetails} />
        </Grid>

        {/* Observaciones */}
        <Grid item xs={12}>
          <BookingRemarks
            room={room}
            hotelsValidateResult={hotelsValidateResult}
            cancelationFee={cancelationFee}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BookingDoneDetail;
